// @flow
import type {Node} from 'react';

import React from 'react';
import SpruceClassName from 'react-spruce/lib/SpruceClassName';

type Props = {
    className?: string,
    modifier?: string,
    peer?: string,
    spruceName: string,
    style?: Object,
    text: Node
};

export default function Loader(props: Props): Node {
    const {
        className,
        modifier,
        peer,
        spruceName,
        style,
        text
    } = props;

    return <div className={SpruceClassName({name: spruceName, modifier, peer, className})} style={style}>
        <div className={SpruceClassName({name: `${spruceName}_spinner`, modifier, className})} />
        <div className={SpruceClassName({name: `${spruceName}_text`, modifier, className})}>{text}</div>
    </div>;
}

Loader.defaultProps = {
    spruceName: 'BlueflagAuthFormLoader'
};
